<template>
    <div class="page bgF6F6F6">

        <header class="pageHeader paddingH16 paddingV8 white_bg">
            <div class="borderLayout">
                <div class="middleRegion" style="line-height: 30px;">
                    <div class="westRegion" style="width: 30px">
                        <router-link to="/auth/distributorAuth" class="icon leftAngleBracketIcon floatL"
                             style="margin-top: 4px;"></router-link>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion alignRight" style="width: 30px">
                        <router-link class="font13r grey" :to="{name : 'distributorAuthHelp'}">帮助</router-link>
                    </div>
                </div>
            </div>
        </header>

        <div class="body" style="padding-bottom: 34px;">

            <form action="javascript:;" @submit="submit()">
                <div class="paddingH10">
                    <div class="paddingH4 paddingV12 red font14r" style="line-height: 19px;">
                        分销商认证仅面向有真实意向的用户开放，认证前需要进行认证审核，请您保证您填写的信息真实有效。
                    </div>
                </div>

                <div class="paddingH10 white_bg">
                    <div class="formRow" style="line-height: 22px;">
                        <div class="columnName" style="width: 120px;">代理商邀请码</div>
                        <div class="columnValue grey888 font14r">
                            283xx79
                        </div>
                    </div>
                </div>

                <div class="paddingH10 white_bg" style="margin-top: 20px;">

                    <div class="formRow">
                        <div class="columnName">姓名</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="请输入您的姓名" required=""
                                   v-model="formData.userName"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">手机号</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="请输入您的手机号" required=""
                               v-model="formData.phone"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">验证码</div>
                        <div class="columnValue alignR">
                            <phoneVerificationCodeInputbox :phone="formData.phone" :length="6" placeholder="验证码"
                                :required="true" v-model="formData.verificationCode"/>
                        </div>
                    </div>
                </div>

                <div class="paddingH10 white_bg" style="margin-top: 20px;">

                    <div class="formRow">
                        <div class="columnName">身份证号</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="请输入您的身份证号" required=""
                                   v-model="formData.idCardNo"/>
                        </div>
                    </div>
                    <div class="paddingV12" style="margin-top: 20px;">
                        <div class="clearfix">上传身份证照片</div>
                        <div class="marginT8">
                            <idCardUploader @changeFrontImage="onChangeFrontImage" @changeBackImage="onChangeBackImage"/>
                        </div>
                    </div>

                </div>

                <div class="marginT16" style="padding: 0 24px; line-height: 18px;">
                    <label class="inline font12r lightgrey">
                        <input type="checkbox" class="orangeCircleTickCheckbox"
                           style="vertical-align: middle; margin-top: -1px;" v-model="agreeProtocol"/>
                        阅读并同意师讯平台
                    </label>
                    <router-link to="/help/agreement/user_agreement" class="orange font12r">《用户服务协议》</router-link>
                    和
                    <router-link to="/help/agreement/privacy_agreement" class="orange font12r">《隐私政策》</router-link>
                </div>

                <div class="marginT8" style="padding: 0 24px;">
                    <button class="submitButton block alignC font14r" type="submit">确认提交</button>
                </div>
            </form>

        </div><!-- end .body -->

        <div class="red">未对接接口</div>

    </div>
</template>

<script>
import Vue from 'vue';
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import {field, popup, cascader } from 'vant';
Vue.use(field);
Vue.use(popup);
Vue.use(cascader);
import imageListSelector from '@/components/imageListSelector';
import phoneVerificationCodeInputbox from '@/components/phoneVerificationCodeInputbox';
import dictSelect from '@/components/dict/dictSelect';
import idCardUploader       from '@/components/form/idCardUploader';

// config and data
import appConfig from '@/appConfig';
import citiesList from '@/data/citiesList_v3'

// util
import appHelper    from '@/util/appHelper';
import consoleApi   from '@/components/platformApi/consoleApi';

const config = {
    name : 'distributorAuthForm',
    title : '申请成为分销商',
    description : '',
    apiConfig : {
        add : {
            url : 'portal/underline/v2/distributor/apply',
            method : 'POST'
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { imageListSelector, phoneVerificationCodeInputbox, dictSelect, idCardUploader },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            formData : {
                name : '',
                companyType : '',
                phone : '',
                verificationCode : '',
                introduce : '',

                idCardNo : '',
                idCardImg : '',
                idCardImg2 : '',
            },

            agreeProtocol : false
        }
    },
    methods : {
        submit() {
            consoleApi.log('[submit] form data:');
            consoleApi.log(this.formData);

            // if (this.formData.companyType == '')
            // {
            //     appHelper.showHint('请填完完整信息');
            //     return;
            // }

            if (!this.agreeProtocol)
            {
                appHelper.showHint('请阅读并勾选同意《分销商认证须知》');
                return;
            }

            this.updateDataItem(this.formData);
            this.save();
        },
        onSubmitSuccess() {
            appHelper.showHint('提交成功');
            appHelper.goToPage('distributorAuthSubmitSuccess');
        }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #F42418;
}
.orange {
    color: #FFB84D;
}
.grey {
    color: #777777;
}
.lightgrey {
    color: #B8C2D6;
}
.grey888 {
    color: #888;
}

.formRow {
    display: flex;
    padding: 8px 0;
    .columnName {
        width: 90px;
        color: #101010;
    }
    .columnValue {
        flex: 1;
        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: solid 1px #BBBBBB;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
        .selectbox {
            border: solid 1px #BBBBBB;
            height: 27px;
            line-height: 27px;
            min-width: 120px;
            background: white;
        }
    }
}
.submitButton {
    display: block;
    width: 100%;
    padding: 0;
    background: #FFB946;
    color: white;
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    border: none;
}
</style>
